import { render, staticRenderFns } from "./SearchProductType.vue?vue&type=template&id=0843b1a7&"
import script from "./SearchProductType.vue?vue&type=script&lang=js&"
export * from "./SearchProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports